export default "__VITE_ASSET__BjCBvdhk__"